/************************************
MODULE:         Basket
WHAT IT DOES:   Add items to basket and removes them
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); } 
}(this, function ($) {

    var minibasket,
        minibasketInner,
        minibasketQuantity,

        isHidden = true,
        isUpdated = null,
        updateTimeout = 4000,
        preloaderMin = 600,
        changeBasketTimeout = 600,
        changeBasketTimer = null,
        tween = null;

    function initBasket() {
        minibasket = $('.js-minibasket');
        minibasketInner = $('.js-minibasket-inner');
        minibasketQuantity = $(".js-basket-items-quantity");

        if (!minibasket.length || !minibasketQuantity.length)
            return;

        isHidden = minibasket.hasClass('hidden');
        var tweenmax = require('tweenmax');

        $(".js-add-to-basket").on('click', addToBasket);
        $(".js-remove-from-basket").on('click', removeFromBasket);
        $('.js-remove-from-basket-quantity').on('change.basket', changeBasketQuantity);
    }

    function addToBasket(e) {
        if(typeof e != 'undefined' && typeof e.preventDefault == "function")
            e.preventDefault();

        var now = new Date(),
            $addButton = $(this),
            skuId = $addButton.data("itemid"),
            quantity = 1,
            addButtonParent = $addButton.parents(".js-add-to-basket-parent");

        if ($addButton.hasClass('disabled'))
            return;

        if (addButtonParent.length) {
            var $quantityControl = addButtonParent.find('.js-add-to-basket-quantity');
            if ($quantityControl.length && $quantityControl.val()) {
                quantity = $quantityControl.val();
            }
        }

        $addButton.addClass('disabled');
        $addButton.attr('data-timer', now.getTime());

        $.ajax({
            url: "/basket.ashx",
            type: "POST",
            data: { action: 'add-product', skuId: skuId, quantity: quantity },
            dataType: "JSON",
            async: false,
            success: basketChangeSuccess.bind(this, $addButton),
            error: basketChangeError.bind(this, $addButton)
        });
    }

    function removeFromBasket(e) {
        if (typeof e != 'undefined' && typeof e.preventDefault == "function")
            e.preventDefault();

        var $removeButton = $(this),
            skuId = $removeButton.data("itemid");

        $.ajax({
            url: "/basket.ashx",
            type: "POST",
            data: { action: 'remove-product', skuId: skuId },
            dataType: "JSON",
            async: false,
            success: basketChangeSuccess.bind(this, null),
            error: basketChangeError.bind(this, null)
        });
    }

    function changeBasketQuantity() {
        if (changeBasketTimer)
            clearTimeout(changeBasketTimer);

        var input = $(this),
            removeParent = input.parents(".js-remove-from-basket-parent");

        if (!removeParent.length)
            return;

        $('.js-remove-from-basket-quantity').not(input).attr('disabled', true);
        //we're looking for a hidden update button and doing server page reload
        

        changeBasketTimer = setTimeout(changeBasketQuantityRefresh.bind(this, removeParent, input), changeBasketTimeout);
    }

    function changeBasketQuantityRefresh(removeParent, input) {
        removeParent.find('.spinbox__btn').off('click');
        removeParent.find('.UpdateButton').click();
    }

    function basketChangeSuccess($addButton, result) {
        if (result.status !== "ok") {
            removeDisabled($addButton);
        } else {
            removeDisabled($addButton, updateQuantity.bind(this, result.totalItems, result.isEmpty, $addButton));
        }
    }

    function basketChangeError($addButton) {
        removeDisabled($addButton);
    }

    //ensures at least preloaderMin milliseconds passed before preloader is removed 
    function removeDisabled($addButton, toCallUpdate) {
        if ($addButton) {
            var now = new Date(),
                was = parseInt($addButton.attr('data-timer')),
                diff = now.getTime() - was;
            if (diff < preloaderMin) {
                setTimeout(arguments.callee.bind(this, $addButton, toCallUpdate), preloaderMin - diff + 1);
                return;
            }
            $addButton.removeClass('disabled');
        }
        if (typeof toCallUpdate == "function")
            toCallUpdate();
    } 

    function updateQuantity(totalItems, isEmpty, $addButton) {
        if ($addButton) {
            $addButton.addClass('updated');
            $(window).trigger('open:simplepopup', { data: { items: totalItems + (totalItems == 1 ? ' item' : ' items') }, template: 'basket-dialog' });
        }

        if (isEmpty)
            hideBasket();
        else
            showBasket();

        minibasketQuantity.text(totalItems);
        isUpdated = new Date();
        minibasket.addClass('updated');
        var timeout = updateTimeout + 1;
        setTimeout(removeUpdated.bind(this, $addButton), timeout);
    }

    function removeUpdated($addButton) {
        var now = new Date(),
            interval = now - isUpdated;
        if ($addButton)
            $addButton.removeClass('updated');
    }

    function showBasket() {
        if (!isHidden)
            return;
        tweenPromote(tween);
        tween = new TimelineMax({ onComplete: tweenComplete });
        if (window.App.globals.isTabletSmall) {
            tween.fromTo(minibasket, 0.3, { maxHeight: 0 }, { maxHeight: minibasket.children().first().outerHeight() });
            tween.fromTo(minibasketInner, 0.3, { opacity: 0 }, { opacity: 1 }, "-=0.3");
        } else {
            tween.fromTo(minibasket, 0.3, { maxWidth: 0 }, { maxWidth: minibasketInner.outerWidth() });
            tween.fromTo(minibasketInner, 0.3, { opacity: 0 }, { opacity: 1 });
        }
        tween.play();
        isHidden = false;
        minibasket.removeClass('hidden');
    }

    function hideBasket() {
        if (isHidden)
            return;
        tweenPromote(tween);
        tween = new TimelineMax({ onComplete: tweenComplete });
        if (window.App.globals.isTabletSmall) {
            tween.fromTo(minibasket, 0.3, { maxHeight: minibasket.outerHeight() }, { maxHeight: 0 });
            tween.fromTo(minibasketInner, 0.3, { opacity: 1 }, { opacity: 0 }, "-=0.3");
        } else {
            tween.fromTo(minibasketInner, 0.3, { opacity: 1 }, { opacity: 0 });
            tween.fromTo(minibasket, 0.3, { maxWidth: minibasketInner.outerWidth() }, { maxWidth: 0 });
        }
        tween.play();
        isHidden = true;
        minibasket.addClass('hidden');
    }

   

    function tweenComplete() {
        minibasket.removeAttr('style');
        if (window.App.globals.isTabletSmall) {
            $(window).trigger('resize:mobilemenu');
        }
    }

    function tweenPromote(tween) {
        if (typeof tween == 'undefined' || tween == null)
            return;

        if (typeof tween.progress == 'function' && tween.progress() < 1) {
            tween.pause();
            tween.progress(1);
        }

        if (typeof tween.destroy == 'function') {
            tween.destroy();
        }
    }

    return {
        init: initBasket
    };
}));


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.basket.js
 ** module id = 33
 ** module chunks = 24
 **/